<template>
  <div id="upload-view">

    <v-container>
    <div v-if="currentFile">
      <div>
        <v-progress-linear
          v-model="progress"
          color="light-blue"
          height="25"
          reactive
        >
          <strong>{{ progress }} %</strong>
        </v-progress-linear>
      </div>
    </div>

    <v-row no-gutters justify="center" align="center">
      <v-col cols="10">
        <v-file-input
  
          show-size
          label="File input"
          @change="selectFile"
          :key="uploadKey"
        ></v-file-input>
      </v-col>

      <v-col cols="2" class="pl-2">
        <v-btn color="success" dark small @click="uploadFile">
          Upload
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-progress-circular v-show="in_progress"
          :indeterminate="in_progress"
          size="48"
          class="ml-2"
    ></v-progress-circular>

    <span class="in-progress" v-if="in_progress"><h3>uploading, saving and resizing image</h3></span>

    <PhotoEdit />

    <v-alert v-if="message" border="left" color="blue-grey" dark>
      {{ message }}
    </v-alert>

    </v-container>
    <PhotoList />

  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import PhotoList from '@/components/image/List'
import PhotoEdit from '@/components/image/Edit'
import { mapState } from 'vuex'

export default {
  name: "Upload",
  components: {
    VueTagsInput,
    PhotoEdit,
    PhotoList,
  },
  data() {
    return {
      message: '',
      selectedFiles: undefined,
      currentFile: undefined,
      tag: '',
      tags: [],
      id: this.$route.params.id,
      fileInfos: [],
      in_progress: false,
      uploadKey: 0
    }
  },

  computed: {
    ...mapState({
        progress: state => state.image.progress,
        loading: state => state.image.loading,
        image_id: state => state.image.last_uploaded
    }),
    filteredByAll() {
        return this.$store.getters['image/filteredByAll']
    },
    filteredByUser() {
        return this.$store.getters['image/filteredByUser']
    },
    images () {
        let images = []
        if ( this.id ) images = this.filteredByUser(this.id)
        return images
    }
  },
  watch: {
      image_id: function() {
          this.$store.dispatch('image/setProgress', 0)
          this.in_progress = false
          this.uploadKey++
          
      }
  },
  methods: {
    selectFile(file) {
      this.$store.dispatch('image/setProgress', 0)
      this.currentFile = file
    },

    uploadFile() {
     
      this.$store.dispatch('image/setProgress', 0)

      if (!this.currentFile) {
        this.message = "Please select a file!";
        return;
      }
      this.message = "";

      this.$store.dispatch('image/uploadFile', this.currentFile)

      this.in_progress = true

    }
  },
  created() {
    this.$store.dispatch('image/getImages', {'user': this.id, 'sorting': 'added'})
  }
};
</script>

<style scoped>

img {
  width: 250px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.in-progress {
  padding-top: 5px;
}

#upload-view {
  padding-top: 50px;
}

</style>